import React from 'react'
import { getTranslatedMessage, language } from '../utils/translations';

const styles = {
	root: {
        direction: language === "en" ? "ltr" : "rtl",
        background: "white",
        padding: 10,
        overflowY: 'scroll'
    },
    inputContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
    },
    input: {
		padding: 8,
        fontSize: 16,
        borderRadius: 4,
        border: "2px solid rgba(0,0,0,0.1)",
    },
    asterisk: {
        color: "red",
        fontSize: 12,
        fontWeight: 600,
        margin: "0 4px",
    },
	button: {
		width: 150,
		backgroundColor: 'rgb(169, 207, 77)',
		border: 'solid 1px rgb(169, 207, 77)',
		color: '#ffffff',
		borderRadius: 0,
        padding: '10px 20px',
        margin: '10px 110px',
	}
};

const Asterisk = () => <span style={styles.asterisk}>*</span>;

class PreChatForm extends React.Component {
    state = {
        name: "",
        email: "",
        mobile: "",
        message: "",
    };

    handleChangeField = (field) => ({ target: { value } }) => {
        this.setState({[field]: value});
    };

    handleSubmit = event => {
        const { name, email, mobile, message } = this.state;
        event.preventDefault();
        const pageUrl = window.location;
        const pageTitle = document.title;
        this.props.onSubmit({ name, email, mobile, message, pageTitle, pageUrl });
    };

    render() {
        const { name, email, mobile, message } = this.state;
        return (
            <form
                onSubmit={this.handleSubmit}
                style={styles.root}
            >
                <div style={styles.inputContainer}>
                    <label for="name">{getTranslatedMessage("name")}<Asterisk/></label>
                    <input
                        required
                        type="text"
                        id="name"
                        value={name}
                        name="user_name"
                        style={styles.input}
                        onChange={this.handleChangeField("name")}
                    />
                </div>
                <div style={styles.inputContainer}>
                    <label for="mobile">{getTranslatedMessage("mobile")}<Asterisk/></label>
                    <input
                        required
                        pattern="\+?[0-9٠-٩ \-]+"
                        type="tel"
                        id="mobile"
                        value={mobile}
                        name="user_mobile"
                        style={styles.input}
                        onChange={this.handleChangeField("mobile")}
                        title={getTranslatedMessage("mobile error")}
                    />
                </div>
                <div style={styles.inputContainer}>
                    <label for="mail">{getTranslatedMessage("mail")}</label>
                    <input
                        type="email"
                        id="mail"
                        name="user_mail"
                        value={email}
                        style={styles.input}
                        onChange={this.handleChangeField("email")}
                    />
                </div>
                <div style={styles.inputContainer}>
                    <label for="msg">{getTranslatedMessage("message")}<Asterisk/></label>
                    <input
                        required
                        id="msg"
                        value={message}
                        name="user_message"
                        style={styles.input}
                        onChange={this.handleChangeField("message")}
                    />
                </div>
                <button style={styles.button} type="submit">
                    {getTranslatedMessage("chat now")}
                </button>
            </form>
        )
    }
}

export default PreChatForm



// WEBPACK FOOTER //
// ./src/components/PreChatForm.js